import oeloxLogo from "../assets/brand/oelox-logo.png";

interface OeloxLogoProps {
  className?: string;
  variant?: "header" | "dark";
}

export function OeloxLogo({ className = "", variant = "header" }: OeloxLogoProps) {
  const variantClass = variant === "header" ? "mix-blend-screen" : "rounded-md";

  return (
    <img
      src={oeloxLogo}
      alt="OELOX"
      draggable={false}
      className={`h-[31px] w-auto max-w-[158px] object-contain object-left select-none md:h-[36px] md:max-w-[178px] ${variantClass} ${className}`.trim()}
    />
  );
}
